<template>
    <div class="checkout-details col-md-12 ls-no-padding-bottom ls-display-flex column-reverse">
      <div v-if="!finished" class="col-md-8 col-sm-6 ls-no-padding-left">
        <form class="ls-form" @submit.prevent="validateBeforeSubmit">
          <fieldset>
            <div class="row">
              <div class="col-md-10 col-xs-12">
                <MaterialInput
                  type="text"
                  ico="fa fa-user"
                  v-model="name"
                  v-validate="'required|alpha_spaces'"
                  :class="{ 'material--active material--has-errors': errors.has($t('payments.attributes.card.name')) }"
                  :data-vv-name="$t('payments.attributes.card.name')">
                    {{ $t('payments.attributes.card.name') }}
                    <small class="material-errors" slot="help-message" v-if="errors.has($t('payments.attributes.card.name'))">{{ errors.first($t('payments.attributes.card.name')) }}</small>
                    <i v-if="!errors.has($t('payments.attributes.card.name'))" aria-hidden="true"></i>
                </MaterialInput>
              </div>
            </div>
            <div class="ls-clearfix"></div>
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <MaterialInput
                  type="text"
                  ico="fa fa-credit-card"
                  v-model="card_number"
                  v-validate="'required|min:14'"
                  maxlength="16"
                  :class="{ 'material--active material--has-errors': errors.has($t('payments.attributes.card.number')) }"
                  :data-vv-name="$t('payments.attributes.card.number')">
                    {{ $t('payments.attributes.card.number') }}
                    <small class="material-errors" slot="help-message" v-if="errors.has($t('payments.attributes.card.number'))">{{ errors.first($t('payments.attributes.card.number')) }}</small>
                    <i v-if="!errors.has($t('payments.attributes.card.number'))" aria-hidden="true"></i>
                </MaterialInput>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-xs-12">
                <MaterialInput
                  type="select"
                  :select-arrow="true"
                  :required="true"
                  @input="(e) => { this.setBrand(e) }"
                  ico="fa fa-credit-card-alt"
                  :class="{ 'material--active material--has-errors': errors.has($t('payments.attributes.card.brand')) }"
                  :data-vv-name="$t('payments.attributes.card.brand')">
                  {{ $t('payments.attributes.card.brand') }}
                  <option slot="options" value="visa">VISA</option>
                  <option slot="options" value="mastercard">MASTERCARD</option>
                  <option slot="options" value="elo">ELO</option>
                  <option slot="options" value="american_express">AMEX</option>
                  <option slot="options" value="hipercard">HIPERCARD</option>

                  <small class="material-errors" slot="help-message" v-if="errors.has($t('payments.attributes.card.brand'))">{{ errors.first($t('payments.attributes.card.brand')) }}</small>
                  <i v-if="!errors.has($t('payments.attributes.card.brand'))" aria-hidden="true"></i>
                  <label for="splits" slot="ico-select">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                  </label>
                </MaterialInput>
              </div>
            </div>
            <div class="ls-clearfix"></div>
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <MaterialInput
                  type="text"
                  ico="fa fa-lock"
                  v-model="cvv"
                  v-validate="'required|min:3'"
                  maxlength="4"
                  :class="{ 'material--active material--has-errors': errors.has($t('payments.attributes.card.cvv')) }"
                  :data-vv-name="$t('payments.attributes.card.cvv')">
                    {{ $t('payments.attributes.card.cvv') }}
                    <small class="material-errors" slot="help-message" v-if="errors.has($t('payments.attributes.card.cvv'))">{{ errors.first($t('payments.attributes.card.cvv')) }}</small>
                    <i v-if="!errors.has($t('payments.attributes.card.cvv'))" aria-hidden="true"></i>
                </MaterialInput>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-xs-12">
                <MaterialInput
                  type="text"
                  ico="fa fa-calendar"
                  v-mask="'99/9999'"
                  v-model="expiration_date"
                  v-validate="'required|valid_mm_yyyy|date_format:MM/yyyy'"
                  :class="{ 'material--active material--has-errors': errors.has($t('payments.attributes.card.expiration_date')) }"
                  :data-vv-name="$t('payments.attributes.card.expiration_date')">
                    {{ $t('payments.attributes.card.expiration_date') }}
                    <small class="material-errors" slot="help-message" v-if="errors.has($t('payments.attributes.card.expiration_date'))">{{ errors.first($t('payments.attributes.card.expiration_date')) }}</small>
                    <i v-if="!errors.has($t('payments.attributes.card.expiration_date'))" aria-hidden="true"></i>
                </MaterialInput>
              </div>
            </div>
            <div class="ls-clearfix"></div>
            <div v-if="invoice.yapay">
              <div class="col-md-6 col-xs-12">
                <div v-if='!brand'>
                  <small>{{ $t('payments.labels.select_brand_to_show_split') }}</small>
                  <MaterialInput type="select" ico="fa fa-clone" :disabled='true'>
                      {{ $t('payments.attributes.split_number') }}
                    <i class="fa fa-chevron-down" slot="ico-select" aria-hidden="true"></i>
                  </MaterialInput>
                </div>
                <div v-else>
                  <MaterialInput
                    type="select"
                    ico="fa fa-clone"
                    :select-arrow="true"
                    v-model="split_number"
                    name='splits'
                    ref='splits'
                    v-validate="'required'"
                    :data-vv-name="$t('payments.attributes.split_number')">
                      {{ $t('payments.attributes.split_number') }}
                    <option slot="options" v-for="split in yapay_splits" v-bind:value="split.split">
                      {{ yapaySplitDescription(split) }}
                    </option>
                    <i class="fa fa-chevron-down" slot="ico-select" aria-hidden="true"></i>
                  </MaterialInput>
                </div>
              </div>
            </div>
            <div v-else-if="invoice.payment_settings.max_split" class="row">
              <div class="col-md-6 col-xs-12">
                <MaterialInput
                  type="select"
                  ico="fa fa-clone"
                  :select-arrow="true"
                  v-model="split_number"
                  name='splits'
                  ref='splits'
                  v-validate="'required'"
                  :data-vv-name="$t('payments.attributes.split_number')">
                    {{ $t('payments.attributes.split_number') }}
                  <option slot="options" v-for="split in invoice.payment_settings.max_split" v-bind:value="split">
                    {{ splitDescription(split) }}
                  </option>
                  <i class="fa fa-chevron-down" slot="ico-select" aria-hidden="true"></i>
                </MaterialInput>
              </div>
            </div>
            <div class="ls-clearfix"></div>
            <div class="row">
              <div class="col-md-12">
                <input
                    class="ls-float-left"
                    type="checkbox"
                    v-model="recurrent" />
                <label class="ls-label">
                  <p><span class="checkbox-text ls-sm-margin-left">{{ $t('payments.labels.recurring_card') }}</span></p>
                </label>
              </div>
              <div class="col-md-5 ls-float-right">
                <button class="btn btn-act next ls-sm-margin-bottom">Finalizar pagamento</button>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="col-md-4 col-sm-6 ls-no-padding-left no-padding ls-md-margin-bottom">
        <div class="full-height ls-no-padding-left ls-no-padding-right">
        <invoice-details :invoice="invoice"></invoice-details>
        </div>
      </div>
    </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import * as location from 'src/utils/location'
  import money from 'src/utils/money'
  import InvoiceDetails from './components/InvoiceDetails.vue'
  import MaterialInput from '../../components/shareds/MaterialInput.vue'

  export default {
    props: ['message'],
    components: { InvoiceDetails, MaterialInput },
    data () {
      return {
        name: '',
        cvv: '',
        money: money,
        expiration_date: '',
        recurrent: true,
        card_number: '',
        brand: '',
        finished: false,
        split_number: '1',
        yapay_splits: '',
        steps: [
          {
            description: this.$t('payments.messages.approved_by_card'),
            icon: 'fa fa-check-circle-o'
          },
          {
            description: this.$t('subscribe.messages.signature_will_only_be_approved_after_payment_confirmation'),
            icon: 'fa fa-file-text-o'
          }
        ]
      }
    },
    methods: {
      ...mapActions(['loadSellerData', 'loadInvoiceById', 'pay', 'loadSetting', 'getSplits']),
      ...mapMutations(['clearFlash', 'addFlash']),
      getUsernameFromUrl: function () {
        return location.getUsername()
      },
      validateBeforeSubmit () {
        this.$loader.show()
        this.$validator.validateAll().then(this.afterValidate)
      },
      setBrand (e) {
        if (this.invoice.yapay) {
          this.yapay_splits = this.splits.filter(function (x) {
            return x.payment_method_name.replace(/\s/g, '').split(/(?=[A-Z])/).join('_').toLowerCase() === e
          })
          if (this.yapay_splits[0]) {
            this.yapay_splits = this.yapay_splits[0].splittings
          } else {
            this.yapay_splits = [
              {
                split: 1,
                value_split: this.invoice.amount_due,
                value_transaction: this.invoice.amount_due
              }
            ]
          }
        }
        // Utilizado para corrigir problema do IE com eventos
        this.brand = e
      },
      afterValidate (result) {
        this.clearFlash()
        if (result) {
          var self = this
          this.pay(this.payParams())
          .then(function (response) {
            self.afterPay(response)
          })
        } else {
          this.$loader.hide()
        }
      },
      trayAccount () {
        return window.location.host.split('.')[0] === 'tray'
      },
      splitDescription (split) {
        return split + 'x de R$' + this.money.parseViewValue(this.invoice.amount_due / split)
      },
      yapaySplitDescription (split) {
        if (parseFloat(split.value_transaction) === parseFloat(this.invoice.amount_due)) {
          return split.split + 'x de R$' + split.value_split + ' (sem juros)'
        } else {
          return split.split + 'x de R$' + split.value_split + ' (R$' + split.value_transaction + ' com juros)'
        }
      },
      mountSplitDescription (split, tax) {
        let totalValue = '  (R$' + this.money.parseViewValue(this.invoice.amount_due * tax) + ' com juros)'
        return split + 'x de R$ ' + this.money.parseViewValue((this.invoice.amount_due * tax) / split) + totalValue
      },
      afterPay (response) {
        if (response.status === 200 && (response.data.invoice.status === 'paid' || response.data.invoice.status === 'awaiting_approval')) {
          this.finished = true
          this.$parent.loadCardDone()
          this.addFlash({ message: 'Recebemos seu pagamento.', type: 'ls-alert-success' })
        }
        this.$loader.hide()
      },
      payParams () {
        var card = { name: this.name, number: this.card_number, cvv: this.cvv, expiration_date: this.expiration_date }
        return { id: this.$route.params.id, method: 'card', payment_method: this.brand, split_number: this.split_number, recurrent: this.recurrent, card: card }
      }
    },
    mounted () {
      if (!this.invoice.yapay) return setTimeout(this.$loader.hide, 700)
      this.$loader.show()
      this.getSplits({price: this.invoice.amount_due}).then(this.$loader.hide)
    },
    computed: {
      ...mapGetters(['basicSeller', 'invoice', 'splits']),
      invoice_id () {
        return this.$route.params.id
      }
    }
  }
</script>
<style>
  @media (max-width: 767px)
  {
    .column-reverse {
      display: flex !important;
      flex-direction: column-reverse;
    }
    .no-padding {
      padding: 0px;
    }
  }
</style>
<style lang="scss" scoped>
  .payment-info {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    list-style: none;
    i {
      font-size: 40px;
      float: left;
      display: inline-block;
      padding: 0px 15px 0px 0px;
      @media screen and (max-width: 768px) {
        font-size: 28px;
        float: left;
        display: inline-block;
        padding: 0px 30px 27px 0px;
      }
    }
  }
  .checkout-details {
    display: flex;
    justify-content: stretch;
    padding: 15px;
    @media screen and (max-width: 768px) {
      display: block;
      padding: 0;
      .order-box {
        margin-bottom: 40px;
      }
    }
  }
  .checkbox-text {
    font-size: 11px;
    color:#6E6E6E;
  }
</style>



// WEBPACK FOOTER //
// Card.vue?ec8bdea4